import { Path } from '@/main/router/routerPath';

import { NAME, CRUMB_LABEL_KEY } from './constants';
import Edit from './Edit.vue';
import List from './List.vue';

export const router = new Path(NAME, { Edit, List }, CRUMB_LABEL_KEY);
